module.exports = __webpack_public_path__ + "img/2892402-57-01.8ad768ae.png";